import { apolloClient } from '~/apollo-client';
import {
  Flex_DeleteLmiProofDocUploadMutation,
  Flex_DeleteLmiProofDocUploadMutationVariables,
} from '~/typings/graphql';
import { DELETE_LMI_PROOF_DOC_UPLOAD } from './delete-lmi-proof-doc-upload.queries';

export type DeleteLMIProofDocUploadParams = {
  id: number;
};

export type DeleteLMIProofDocUploadResponse = {
  id: number;
};

export const deleteLmiProofDocUpload = async ({
  id,
}: DeleteLMIProofDocUploadParams): Promise<DeleteLMIProofDocUploadResponse> => {
  const response = await apolloClient.mutate<
    Flex_DeleteLmiProofDocUploadMutation,
    Flex_DeleteLmiProofDocUploadMutationVariables
  >({
    mutation: DELETE_LMI_PROOF_DOC_UPLOAD,
    variables: { id },
  });

  return { id: response.data?.deleteLMIProofDocUpload.id! };
};
